import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";

/** Selects the converged Pay Component Import experience. */
export function usePayComponentImportRedesignEnabled(): boolean {
  return useFeatureFlagValue(FeatureFlag.EnablePayComponentImportRedesign);
}
